import * as React from 'react';
import { PageTitle, PaginatorAndListSettings, Search, Section, useCacheQuery } from 'gossamer-front-end';
import { OutboundEmail } from 'cb-model';
import { QueryOptions } from 'gossamer-unified';

export const OutboundEmailSearch = (): React.JSX.Element => {
  const [queryOptions, setQueryOptions] = React.useState({
    where: { and: OutboundEmail.defaultFilters },
    order: OutboundEmail.defaultSort,
  } as QueryOptions);
  const gCacheQueryItem = useCacheQuery(OutboundEmail, queryOptions);
  return (
    <>
      <PageTitle title="Search for Outbound Emails" />
      <Section>
        <PaginatorAndListSettings
          entity={OutboundEmail}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
